import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .notice {
    background-color: ${theme.primaryRed};
    padding: 10px;
    text-align: center;

    .text-notice {
      color: ${theme.white};
      letter-spacing: 0.5px;
      p {
        padding: 0;
        margin: 0;
      }
    }
  }

  .desktop {
    padding: 0 40px;
    height: 90px;
    background: #fff2e6;
    display: flex;
    align-items: center;
    /* margin-bottom: 20px; */
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 22%);
    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left-block {
        .logo-image {
        }
      }

      .right-block {
        .current-location-block {
          display: flex;
          align-items: center;
          border-radius: 40px;
          background: ${theme.white};
          height: 40px;
          padding: 0 20px 0 16px;
          cursor: pointer;
          overflow: hidden;

          .icon-marker {
            display: flex;
            align-items: center;
          }

          .current-location-name {
            display: flex;
            align-items: center;
            margin-left: 10px;
            width: 100%;

            .icon-arrow-down {
              margin-left: 6px;
            }
          }
        }

        .phone {
          .icon-phone {
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
              font-size: 18px;
            }
          }
          .ant-typography {
            color: ${theme.primaryRed};
          }
        }

        .profile-block {
          display: flex;
          align-items: center;
          border-radius: 40px;
          background: ${theme.white};
          height: 40px;
          padding: 0 16px;
          cursor: pointer;
          width: 150px;
          overflow: hidden;

          .icon-user {
            display: flex;
            align-items: center;
          }

          .profile-name {
            display: flex;
            align-items: center;
            margin-left: 8px;
            width: 100%;

            .text-name {
              width: 65%;
            }

            .icon-arrow-down {
              margin-left: 6px;
            }
          }
        }
      }
    }
  }

  .mobile {
    display: none;
  }

  @media (max-width: ${breakpoint.lg}) {
    .desktop {
      display: none;
    }

    .mobile {
      display: block;
      background: ${theme.white};
      padding: 9px 0;
      box-shadow: 0 0 4px 0 rgb(0 0 0 / 22%);
      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon-block {
          width: fit-content;
          cursor: pointer;
        }
        .left-block {
          flex: 1;
          .icon-block {
            justify-content: center;
            align-items: center;
            display: flex;
          }
        }
        .center-block {
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 1;
          .logo-image {
            width: 75px;
          }
        }
        .right-block {
          display: flex;
          justify-content: flex-end;
          flex: 1;
          .icon-block {
            justify-content: center;
            align-items: center;
            display: flex;
          }
        }
      }
    }
  }
`
